import apisauce from 'apisauce'
import Config from 'APP/Config'

type LoginStore = {
  accessToken: string
}

type Practitioner = {
  id: string
  app_id: string
  first_name: string
  last_name: string
  locale: string
  avatar_url: string
}

type PractitionersResponse = {
  data: Practitioner[]
}

type PractitionersMap = Record<string, Practitioner>

const instances: Record<
  string,
  {
    getPractitionersInfo: () => Promise<PractitionersMap>
    setToken: (accessToken: string) => void
  }
> = {}
const create = (loginStore: LoginStore, baseURL = Config.USHER_DOMAIN) => {
  const authToken = loginStore.accessToken
  const thisInstanceId = baseURL + authToken

  if (instances[thisInstanceId]) return instances[thisInstanceId]

  const api = apisauce.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    timeout: 30000,
  })

  const setToken = (accessToken: string) => {
    api.setHeader('Authorization', 'Bearer ' + accessToken)
  }

  const getPractitionersInfo = (): Promise<PractitionersMap> => {
    return new Promise((resolve, reject) => {
      return api.get<PractitionersResponse>('/physicians/info').then((response) => {
        if (response.ok) {
          const practitioners = response.data && response.data.data
          if (practitioners && practitioners.length > 0) {
            const practitionersMap: PractitionersMap = {}
            practitioners.forEach((p) => {
              practitionersMap[p.id] = p
            })
            resolve(practitionersMap)
          } else {
            reject({
              error: 'EMPTY_RESPONSE',
              message: 'No practitioners were included in the response',
            })
          }
        } else {
          reject({
            error: response.originalError.code,
            message: response.originalError.message,
          })
        }
      })
    })
  }
  instances[thisInstanceId] = {
    getPractitionersInfo,
    setToken,
  }
  return instances[thisInstanceId]
}

export default {
  create,
}
